<template>
    <div class="index-box">
        <div class="left-box" @click="closeMsg" :class="!leftShort?'short':''">
            <div class="name-tit d-flex"><img src="../../assets/images/logo.png" alt=""><span v-if="leftShort">场租宝</span></div>
            <div class="user-info">
                <mu-avatar color="teal" v-if="role==1" :size="leftShort?60:24">总</mu-avatar>
                <mu-avatar color="teal" v-if="role==2" :size="leftShort?60:24">城</mu-avatar>
                <mu-avatar color="teal" v-if="role==3" :size="leftShort?60:24">类</mu-avatar>
                <mu-avatar color="teal" v-if="role==4" :size="leftShort?60:24">管</mu-avatar>
            </div>
            <div class="menu" @mouseleave="hideTip()">
                <div v-for="item in menuData" :key="item.id" >
                    <div  class="item" v-if="item.isShow"  :class="item.id==curIndex?'active':''"  @click="changePage(item)" @mouseenter="showTip(item)">
                        <div class="item-con"><i :class="item.icon" ></i><span v-if="leftShort">{{item.name}}</span><p class="tip" :class="tipId==item.id?'active':''"><span>{{item.name}}</span></p></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right-box" :class="!leftShort?'active':''">
            <div class="right-banner">
                <div class="handle-icon" @click="changeLeft">
                    <i v-if="leftShort" class="el-icon-s-fold"></i>
                    <i v-else class="el-icon-s-unfold"></i>
                </div>
                <div class="user" @click="openMsg">
                    <img src="../../assets/images/avatar.jpg" alt="">
                    <i class="el-icon-arrow-down" :class="topMsg?'active':''"></i>
                </div>
                <div class="user-setting" v-if="userinfo&&topMsg">
                    <div class="title">账号信息</div>
                    <div class="item user-title">用户名：{{userinfo.username}}</div>
                    <div class="item user-role">角色：{{userinfo.role_name}}</div>
                    <div class="item last-time">最后登录时间：{{userinfo.last_login}}</div>
                    <div class="btn d-flex">
                        <el-button type="text" @click="toSetting">账号设置</el-button>
                        <el-button type="text" @click="toLogout">退出登录</el-button>
                    </div>
                </div>
            </div>
            <div class="right-content" @click="closeMsg">
                <router-view @changeRouter="changePage" />
            </div>
        </div>
    </div>
</template>

<script>
    import {searchCity} from '../../api/city'
    import {mapState,mapMutations} from 'vuex'
    export default {
        name: "index",
        data(){
            return{
                topMsg:false,
                leftShort:true,
                curIndex:1,
                tipId:-1,
                role:'',
                userinfo:'',
                menuData:[
                    {id:1,url:'/home/home',icon:'el-icon-s-home',name:'首页',isShow:true},
                    {id:2,url:'/alliance/alliance',icon:'el-icon-s-promotion',name:'加盟商管理',isShow:true},//总后台显示
                    {id:3,url:'/alliance/alliance',icon:'el-icon-s-promotion',name:'代理商管理',isShow:true},//城市代理显示
                    {id:4,url:'/account/account',icon:'el-icon-s-opportunity',name:'账号管理',isShow:true},
                    {id:5,url:'/site/site',icon:'el-icon-s-grid',name:'场地管理',isShow:true},
                    {id:6,url:'/service/service',icon:'el-icon-s-shop',name:'服务商管理',isShow:true},
                    {id:7,url:'/user/user',icon:'el-icon-s-custom',name:'用户管理',isShow:true},
                    {id:8,url:'/order/order',icon:'el-icon-s-help',name:'订单管理',isShow:true},
                    {id:9,url:'/demand/demand',icon:'el-icon-circle-plus',name:'需求管理',isShow:true},
                    {id:10,url:'/withdraw/withdraw',icon:'el-icon-s-finance',name:'财务管理',isShow:true},
                    {id:11,url:'/wechat/wechat',icon:'el-icon-s-cooperation',name:'小程序管理',isShow:true},
                    {id:12,url:'/setting/setting',icon:'el-icon-s-tools',name:'系统设置',isShow:true},
                    {id:13,url:'/log/log',icon:'el-icon-s-management',name:'安全日志',isShow:true},
                ],
                role_ads:[],
            }
        },
        mounted(){
            this.getCityList();
            this.userinfo=JSON.parse(localStorage.getItem('USERINFO'));
            this.role_ads=JSON.parse(localStorage.getItem('USERINFO')).role_adm_access_ids;
            let url=this.$route.fullPath.split('/')[1];
            this.menuData.map(val=>{
                if(val.url.split('/')[1]==url){
                    this.tipId=-1;
                    this.curIndex=val.id;
                }
            });
            this.role=localStorage.getItem('ROLE');
            console.log('this.role',this.role)
            if(this.role==1){
                this.menuData[2].isShow=false;
            }else if(this.role==2){
                this.menuData[1].isShow=false;
                this.menuData[2].isShow=false;
                this.menuData[3].isShow=false;
                this.menuData[7].isShow=false;
                this.menuData[9].isShow=false;
            }else if(this.role==3){
                this.menuData[1].isShow=false;
                this.menuData[2].isShow=false;
                this.menuData[3].isShow=false;
                this.menuData[7].isShow=false;
                this.menuData[9].isShow=false;
            }else{
                this.menuData[1].isShow=false;
                this.menuData[2].isShow=false;
                this.menuData[3].isShow=false;
                this.menuData[9].isShow=false;
                this.menuData[7].isShow=false;
                this.menuData[9].isShow=false;
                if(this.role_ads.length>0){
                    this.menuData[7].isShow= this.role_ads.includes('33');
                    this.menuData[8].isShow= this.role_ads.includes('35');
                }

            }
        },
        methods:{
            ...mapMutations(['setCityArr']),
            closeMsg(){
                this.topMsg=false;
            },
            changeLeft(){
                this.leftShort=!this.leftShort;
            },
            openMsg(){
                this.topMsg=!this.topMsg;
            },
            changePage(item){
                this.tipId=-1;
                this.curIndex=item.id;
                this.$router.push({path: item.url});
            },
            toLogout(){
                window.localStorage.removeItem('UTOKEN');
                window.localStorage.removeItem('USERINFO');
                window.localStorage.removeItem('ROLE');
                this.$router.push({path: '/login'});
            },
            toSetting(){
                this.topMsg=false;
                this.$router.push({path: '/setting/setting'});
            },
            showTip(item){
                if(!this.leftShort){
                    this.tipId=item.id;
                }
            },
            hideTip(){
                this.tipId=-1;
            },
            getCityList(){
                searchCity({
                    level:0
                }).then(res=>{
                    if(res.code==1){
                        this.setCityArr(res.data);
                    }
                })
            }
        }
    }
</script>

<style scoped lang="scss">
.index-box{
    display: flex;
    justify-content: space-between;
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: #f7f9fc;
     .left-box{
         width: 220px;
         height: 100%;
         min-height: 100vh;
         background-color: #ffffff;
         box-shadow: 0 0 17px 0 #d3d3d3;
         position: relative;
         z-index: 99;
         transition: all 100ms;
         .name-tit{
             width: 100%;
             text-align: center;
             align-items: center;
             justify-content: center;
             padding: 20px 0;
             font-size: 18px;
             color: #2c3e50;
             img{
                 width: 30px;
                 height: 30px;
                 margin-right: 10px;
             }

         }
         .user-info{
             padding-bottom: 20px;
             border-bottom: 1px solid #eaeaea;
             img{
                 width: 70px;
                 height: 70px;
                 box-shadow: 2px 2px 10px #aaa;
                 border-radius: 50%;
             }
             p{
                 margin: 0;
                 font-size: 16px;
                 text-align: center;
                 color: #2c3e50;
             }
         }
        .menu{
            box-sizing: border-box;
            .item{
                text-align: left;
                color: #666;
                padding: 12px 20px;
                cursor: pointer;
                font-size: 14px;
                position: relative;
                color: #54667A;
                .item-con{
                    display: flex;
                    i{
                        font-size: 20px;
                        margin-right: 8px;
                        color: #54667A;
                    }
                }
                &.active{
                    color: #4890f7;
                    font-weight: bold;
                    i{
                        color: #4890f7;
                    }
                }
                .tip{
                    display: none;
                    position: absolute;
                    top: 0;
                    left: 60px;
                    span{
                        display: inline-block;
                        white-space: nowrap;
                        margin-left: 10px;
                        padding: 10px 20px;
                        background-color: #fff;
                        box-shadow: 0 2px 6px 0 #e1e5eb;
                        border-radius: 4px;
                    }
                    &.active{
                        display: block;
                    }
                }
            }
        }
         &.short{
             width: 60px;
             .name-tit{
                 flex-direction: column;
                 justify-content: center;
                 font-size: 14px;
                 text-align: center;
                 img{
                     width: 20px;
                     height: 20px;
                     margin: 0 auto;
                 }

             }
             .user-info{

                 img{
                     width: 30px;
                     height: 30px;
                     box-shadow: 2px 2px 10px #aaa;
                     border-radius: 50%;
                 }
                 p{
                     margin: 0;
                     font-size: 14px;
                     text-align: center;
                     color: #2c3e50;
                 }
             }
         }
     }
     .right-box{
        height: 100%;
         width: calc(100% - 220px);
         &.active{
             width: calc(100% - 60px);
         }
         .right-banner{
             position: relative;
             width: 100%;
             height: 60px;
             background-color: #30323f;
             padding: 0 20px;
             display: flex;
             align-items: center;
             justify-content: space-between;
             .user{
                 display: flex;
                 justify-content: flex-end;
                 align-items: center;
                 img{
                     width: 40px;
                     height: 40px;
                     border-radius: 50%;
                     margin-right: 10px;
                 }
                 i{
                    color: #ffffff;
                    transition: all 400ms;
                     &.active{
                         transform: rotate(180deg);
                         transform-origin: center center;
                     }
                 }
             }
             .handle-icon{
                 font-size: 24px;
                 color: #eee;
             }
         }
         .user-setting{
             position: absolute;
             bottom: -200px;
             right: 10px;
             padding-top: 20px;
             background-color: #fff;
             width: 300px;
             box-shadow: 0 0 6px 0 rgb(0,0,0,0.2);
             border-radius: 5px;
             z-index: 99;
             .title{
                 font-size: 18px;
                 text-align: left;
                 padding-bottom: 10px;
                 padding-left: 20px;
             }
             .item{
                 font-size: 15px;
                 text-align: left;
                 line-height: 1.7;
                 padding-left: 20px;
             }
             .btn{
                 margin-top: 12px;
                 width: 100%;
                 height: 50px;
                 text-align: center;
                 border-top: 1px solid #eaeaea;
                 button{
                     flex: 1;
                     border-right: 1px solid #eaeaea;
                     &:last-child{
                         border-right: none;
                     }
                 }
             }
         }
        .right-content{
            height: calc(100vh - 60px);
            overflow: auto;
            min-width: 1000px;
        }
     }
 }
</style>
